import { MetaDefinition } from '@angular/platform-browser';
import { ResolveFn } from '@angular/router';
import { noIndexMetaTag } from '../../lib/meta-helpers';

export const simpleNoIndexMetaResolver: ResolveFn<{ tags: MetaDefinition[] }> = () => {
  return {
    tags: [noIndexMetaTag],
  };
};
